import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { NAMESPACES } from '~/i18n/namespaces';
import HBText from '@honeybook/hbui/dist/components/HBText/HBText';
import { useWindowSize } from '@honeybook/hbui/dist/components/common/useWindowSize';

export const SignupPageWevenContent = () => {
    const { isLargeUp } = useWindowSize();
    const { t } = useTranslation(NAMESPACES.SIGNUP, {
        keyPrefix: 'weven'
    });

    return isLargeUp ? (
        <TextWrapper>
            <Title type="display48">
                {/*@ts-ignore*/}
                <Trans t={t} i18nKey="title">
                    <HBText type="display48" color="purple500" />
                </Trans>
            </Title>
            <PlansDescription type="emphasis16" tag="p">
                {t('plans_description')}
            </PlansDescription>
            <TextDescription type="body16" tag="p">
                {t('description')}
            </TextDescription>
        </TextWrapper>
    ) : (
        <></>
    );
};

// -------------------------------- Styles -------------------------------- //

const Title = styled(HBText)`
    line-height: 60px;
    margin: 10px 0 20px;
`;

const TextWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    max-width: 460px;
`;

const TextDescription = styled(HBText)`
    max-width: 420px;
`;

const PlansDescription = styled(HBText)`
    margin-bottom: 8px;
`;
